<template>
  <q-page padding>
    <div class="row col-12 justify-between">
      <div>
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Detalhe da Requisição: #{{ requisicaoId }}
        </p>
      </div>
      <div>
        <router-link :to="{ name: 'backoffice/listagem-requisicoes-teste' }">
          <div
            style="cursor: pointer"
            class="row items-center text-weight-bold text-brand-5 q-mr-md container-link-voltar"
          >
            <q-icon class="q-mr-sm icon-voltar" name="west" color="brand-5" />
            <span class="texto-titulo">Voltar</span>
          </div>
        </router-link>
      </div>
    </div>
    <div
      class="row col-12 text-brand-5 text-weight-bold q-mt-md q-gutter-sm q-ml-lg container-inputs"
    >
      <div class="col-md col col-xs-3 input-status-container">
        <div class="titulo-inputs">Unidade</div>
        <q-input
          v-model="objetoUnidade.nome"
          bg-color="brand-7"
          class="input-font"
          disable
          dense
          outlined
        />
      </div>
      <div class="col-md col-lg col-xs-3 input-status-container">
        <div class="titulo-inputs">Status</div>
        <q-input
          v-model="requisicaoDetalhes.status"
          bg-color="brand-7"
          class="input-font"
          disable
          dense
          outlined
        />
      </div>
      <div class="col-md col-lg col-xs-4 input-centro-de-custo-container">
        <div class="titulo-inputs">Centro de Custo</div>
        <q-input
          class="input-font"
          v-model="dados.centroDeCusto"
          bg-color="brand-7"
          disable
          dense
          outlined
        />
      </div>
      <div class="col-md col-lg col-xs-4 input-solicitante-container">
        <div class="titulo-inputs">Nome Solicitante</div>
        <q-input
          v-model="dados.solicitante"
          bg-color="brand-7"
          disable
          class="input-font"
          dense
          outlined
        />
      </div>
      <div class="col-md col-lg col-xs-3 input-compra-container">
        <div class="titulo-inputs">Sol. Compra</div>
        <q-input
          type="number"
          dense
          class="input-font"
          hide-bottom-space
          outlined
          :rules="[(val) => val < 0 || 'Valor não pode ser menor que 0']"
        />
      </div>
      <div class="col-md-12 col-lg-12 col-xs-8 container-input-observacao">
        <div class="q-ml-sm titulo-inputs">Observação</div>
        <q-input
          v-model="dados.descricao"
          bg-color="brand-7"
          disable
          class="input-font"
          dense
          outlined
        />
      </div>
    </div>
    <div class="q-ml-lg q-mt-xl titulo-tabela">
      <div
        class="text-h6 text-brand-5 text-weight-bold q-mb-lg texto-titulo-tabela"
      >
        Produtos Selecionados na Requisição
      </div>
      <div>
        <q-table
          table-header-class="bg-accent text-width-bold"
          :grid="$q.screen.lt.sm"
          :columns="columns"
          :rows="dados.produtos"
          dense
          class="tabela-tamanho-fixo"
          color="primary"
          flat
          :loading="loading"
          :rows-per-page-options="[0]"
          hide-pagination
          hide-bottom
        >
          <template v-slot:item="props">
            <div class="q-pa-xs col-xs-12 col-sm-6 col-md-4">
              <div class="row card">
                <div class="row col-12 q-my-md">
                  <div class="col-3 q-ma-sm">
                    <div
                      v-if="props.row.product_images.length != 0"
                      class="card-img q-ml-sm"
                    >
                      <q-img
                        v-if="props.row.product_images.length != 0"
                        :src="props.row.product_images[0].url"
                        fit="contain"
                        class="img-grid"
                      />
                    </div>
                    <div class="card-img q-ml-sm" v-else>
                      <span class="img-grid"></span>
                    </div>
                  </div>
                  <div class="col text-grid-table q-pr-sm q-mt-sm">
                    <div class="row col-12 text-brand-5">
                      <span class="q-mr-sm">
                        <strong>ID: </strong> {{ props.row.code }} -
                        {{ props.row.pivot.product_id }}</span
                      >
                      <span
                        ><strong> Unidade: </strong>
                        {{ requisicaoDetalhes.vendor.name }}</span
                      >
                    </div>
                    <div class="row col-12 text-brand-5">
                      <span
                        ><strong>Solicitante: </strong>
                        {{ dados.solicitante }}</span
                      >
                    </div>
                    <div class="row col-12 text-brand-5">
                      <span
                        ><strong>Status Atual: </strong>
                        {{ requisicaoDetalhes.status }}</span
                      >
                    </div>
                    <div class="row col-12 text-brand-5">
                      <span
                        ><strong>Produto: </strong> {{ props.row.name }}</span
                      >
                    </div>
                    <div
                      v-if="
                        requisicaoDetalhes.status == 'Pendente' ||
                        requisicaoDetalhes.status == 'Aprovado'
                      "
                      class="row col-12 justify-end"
                    >
                      <q-icon
                        name="manage_search"
                        style="
                          font-size: 28px;
                          margin: 0px 0px 3px 0px;
                          cursor: pointer;
                        "
                        color="black"
                        @click="
                          (item = {
                            nome: props.row.name,
                            id: props.row.code,
                          }),
                            atualizarHistorico++
                        "
                      ></q-icon>
                    </div>
                  </div>
                </div>
                <div class="row q-gutter-sm text-brand-5">
                  <div
                    v-for="(i, index) in lotes"
                    :key="index"
                    class="row q-mb-sm"
                  >
                    <div v-if="i.productId == props.row.id">
                      <div class="row items-center q-mb-sm">
                        <span class="text-campos-lotes"
                          ><strong>Lote</strong></span
                        >

                        <q-select
                          class="input-lote-nome"
                          outlined
                          dense
                          placeholder="Lote"
                          v-model="i.batch"
                          :options="
                            options(
                              props.row.id,
                              props.row.stock[0].batch_control
                            )
                          "
                          :disable="props.row.stock[0].batch_control == 0"
                          @blur="editarNomeLote(i.id, i.batch)"
                        />
                        <q-btn
                          :disable="props.row.stock[0].batch_control == 0"
                          icon="delete"
                          flat
                          dense
                          color="red"
                          class="btn-delete"
                          @click="removerLote(index)"
                        />
                      </div>
                      <div class="row items-center">
                        <span class="text-campos-lotes"
                          ><strong>Qtd</strong></span
                        >
                        <q-input
                          class="input-lote-qtd"
                          :disable="props.row.stock[0].batch_control == 0"
                          type="number"
                          outlined
                          dense
                          v-model="i.amount"
                          @blur="editarQuantidade(i.id, i.amount)"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="q-mb-sm">
                    <div class="row items-center q-mb-sm">
                      <span class="text-campos-lotes"
                        ><strong>Lote</strong></span
                      >

                      <q-select
                        class="input-lote-nome"
                        outlined
                        dense
                        :options="options(props.row.id)"
                        v-model="props.row.batchName"
                        :disable="props.row.stock[0].batch_control == 0"
                      />
                      <q-btn
                        icon="add"
                        flat
                        dense
                        color="brand-1"
                        class="btn-delete"
                        :disable="props.row.stock[0].batch_control == 0"
                        @click="
                          adicionarLote(
                            props.row.id,
                            props.row.quantidade,
                            props.row.batchName
                          ),
                            (props.row.quantidade = 0),
                            (props.row.batchName = '')
                        "
                      />
                      <q-icon
                        v-if="props.row.lotes.length > 0"
                        style="cursor: pointer; margin: 0px 0px 0px 5px"
                        size="17px"
                        name="visibility"
                        color="brand-1"
                        @click="props.expand = !props.expand"
                      />
                    </div>
                    <div class="row items-center">
                      <span class="text-campos-lotes"
                        ><strong>Qtd</strong></span
                      >
                      <q-input
                        class="input-lote-qtd"
                        type="number"
                        outlined
                        :disable="props.row.stock[0].batch_control == 0"
                        dense
                        v-model="props.row.quantidade"
                      />
                    </div>
                  </div>
                  <div class="q-ml-md" v-if="props.expand">
                    <div
                      class="text-brand-5 text-weight-medium"
                      v-for="(lote, index) in props.row.lotes"
                      :key="index"
                    >
                      <div
                        class="text-lotes-existentes"
                        v-if="parseFloat(lote.amount) > 0"
                      >
                        <strong>Lote: </strong> {{ lote.batch }} |
                        <strong>Em Estoque: </strong> {{ lote.amount }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row col-12">
                  <div
                    class="row col-6 justify-center q-py-sm items-center"
                    style="background: #2d3e6e; border-radius: 0px 0px 0px 5px"
                  >
                    <div>
                      <span style="color: white; font-size: 12px">Qtd.</span>
                    </div>
                    <div class="arrow-container q-ml-sm">
                      <q-icon
                        name="arrow_left"
                        class="arrow"
                        style="background: #7e7e7e"
                      />
                    </div>
                    <div>
                      <span class="numero q-mx-sm">{{
                        props.row.pivot.amount
                      }}</span>
                    </div>
                    <div class="arrow-container">
                      <q-icon
                        name="arrow_right"
                        class="arrow"
                        style="background: #7e7e7e"
                      />
                    </div>
                  </div>
                  <div
                    class="row col-6 justify-center q-py-sm items-center"
                    style="background: #213864; border-radius: 0px 0px 5px 0px"
                  >
                    <div>
                      <span style="color: white; font-size: 12px"
                        >Entregue:</span
                      >
                    </div>
                    <div class="arrow-container q-ml-sm">
                      <q-icon
                        name="arrow_left"
                        class="arrow"
                        style="background: #fff; color: black"
                        @click="
                          props.row.pivot.new_amount != null &&
                          props.row.pivot.new_amount > 0
                            ? props.row.pivot.new_amount--
                            : ''
                        "
                      />
                    </div>
                    <div class="input-quantidade-container">
                      <q-input
                        type="number"
                        v-model="props.row.pivot.new_amount"
                        borderless
                        class="input-quantidade"
                        bg-color="brand-1"
                        dense
                        :input-style="{
                          color: '#fff',
                        }"
                      />
                    </div>
                    <div class="arrow-container">
                      <q-icon
                        name="arrow_right"
                        class="arrow"
                        style="background: #6391f4"
                        @click="
                          props.row.pivot.new_amount == null
                            ? (props.row.pivot.new_amount = 1)
                            : props.row.pivot.new_amount++
                        "
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template #body-cell-selecionado="props">
            <q-td :props="props">
              <q-btn
                label="Selecionado"
                color="accent"
                dense
                no-caps
                text-color="black"
                disable
                icon="check_circle_outline"
              />
            </q-td>
          </template>
          <template #body-cell-imagem="props">
            <q-td :props="props">
              <div
                v-if="props.row.product_images.length != 0"
                class="img-container"
              >
                <q-img
                  v-if="props.row.product_images.length != 0"
                  :src="props.row.product_images[0].url"
                  fit="contain"
                  style="max-width: 100%; height: 45px"
                />
              </div>
              <div class="img-container" v-else>
                <span class="img-normal"></span>
              </div>
            </q-td>
          </template>
          <template #body-cell-codigo="props">
            <q-td :props="props">
              <div>{{ props.row.code }} - {{ props.row.pivot.product_id }}</div>
            </q-td>
          </template>
          <template #body-cell-nome="props">
            <q-td :props="props">
              <div>{{ props.row.name }}</div>
            </q-td>
          </template>
          <template #body-cell-estoque="props">
            <q-td :props="props">
              {{ retornarValorEstoque(props.row.stock) }}
            </q-td>
          </template>
          <template #body-cell-quantidade="props">
            <q-td :props="props">
              <q-input
                v-model="props.row.pivot.amount"
                type="number"
                outlined
                disable
                bg-color="brand-7"
                dense
                style="width: 100px"
              />
            </q-td>
          </template>
          <template #body-cell-quantidadeEntregue="props">
            <q-td :props="props">
              <q-input
                type="number"
                outlined
                dense
                style="max-width: 100px"
                v-model="props.row.pivot.new_amount"
              />
            </q-td>
          </template>
          <template #body-cell-lote="props">
            <q-td :props="props">
              <div style="width: 360px">
                <div
                  v-for="(lote, index) in lotes"
                  :key="index"
                  class="row q-gutter-sm"
                  style="width: 380px; margin-top: 2px"
                >
                  <div
                    v-if="lote.productId == props.row.id"
                    class="row q-gutter-sm"
                    style="margin: 0px"
                  >
                    <q-select
                      type="text"
                      outlined
                      dense
                      placeholder="Lote"
                      class="q-mb-sm"
                      style="width: 180px"
                      v-model="lote.batch"
                      :options="
                        options(props.row.id, props.row.stock[0].batch_control)
                      "
                      :disable="props.row.stock[0].batch_control == 0"
                      @blur="editarNomeLote(lote.id, lote.batch)"
                    />
                    <q-input
                      :disable="props.row.stock[0].batch_control == 0"
                      type="number"
                      outlined
                      dense
                      style="width: 120px"
                      v-model="lote.amount"
                      @blur="editarQuantidade(lote.id, lote.amount)"
                    />
                    <q-btn
                      :disable="props.row.stock[0].batch_control == 0"
                      style="padding: 0px"
                      icon="delete"
                      flat
                      color="red"
                      @click="removerLote(index)"
                    />
                  </div>
                </div>
                <div
                  class="row q-gutter-sm"
                  style="width: 360px; margin-top: 5px"
                >
                  <q-select
                    :options="options(props.row.id)"
                    v-model="props.row.batchName"
                    :disable="props.row.stock[0].batch_control == 0"
                    outlined
                    dense
                    style="width: 180px"
                  />
                  <q-input
                    type="number"
                    :disable="props.row.stock[0].batch_control == 0"
                    outlined
                    dense
                    style="width: 120px"
                    v-model="props.row.quantidade"
                  />
                  <q-btn
                    :disable="props.row.stock[0].batch_control == 0"
                    style="padding: 0px"
                    color="brand-1"
                    dense
                    no-caps
                    icon="add"
                    flat
                    @click="
                      adicionarLote(
                        props.row.id,
                        props.row.quantidade,
                        props.row.batchName
                      ),
                        (props.row.quantidade = 0),
                        (props.row.batchName = '')
                    "
                  />
                  <q-icon
                    v-if="props.row.lotes.length > 0"
                    style="cursor: pointer; margin: 0px 0px 0px 5px"
                    size="17px"
                    name="visibility"
                    color="brand-1"
                    @click="props.expand = !props.expand"
                  />
                </div>
              </div>
              <div v-if="props.expand">
                <div
                  class="text-brand-5 text-weight-medium"
                  v-for="(lote, index) in props.row.lotes"
                  :key="index"
                >
                  <span v-if="parseFloat(lote.amount) > 0"
                    ><strong>Lote: </strong> {{ lote.batch }} |
                    <strong>Em Estoque: </strong> {{ lote.amount }}</span
                  >
                </div>
              </div>
            </q-td>
          </template>
          <template #body-cell-retiradas="props">
            <q-td :props="props">
              <q-btn
                icon="manage_search"
                flat
                round
                color="black"
                :disable="
                  requisicaoDetalhes.status != 'Pendente' &&
                  requisicaoDetalhes.status != 'Aprovado'
                "
                @click="
                  (item = { nome: props.row.name, id: props.row.code }),
                    atualizarHistorico++
                "
              />
            </q-td>
          </template>
        </q-table>
      </div>
    </div>
    <div class="q-ml-lg q-mt-xl titulo-tabela">
      <div
        class="text-h6 text-brand-5 text-weight-bold q-mb-lg texto-titulo-tabela"
      >
        Histórico da Requisição
      </div>
      <div>
        <q-table
          table-header-class="bg-accent text-width-bold"
          :columns="columns2"
          :loading="loading"
          :grid="$q.screen.lt.sm"
          dense
          :rows="dados.historico"
          class="tabela-tamanho-fixo"
          :rows-per-page-options="[0]"
          color="primary"
          flat
          hide-pagination
          hide-bottom
        >
          <template v-slot:item="props">
            <div class="q-pa-xs col-xs-12 col-sm-6 col-md-4">
              <div class="row card">
                <div class="row col-12 q-my-md">
                  <div class="col-9 text-grid-table q-pa-sm">
                    <div class="row col-12 text-brand-5">
                      <span class="q-mr-sm">
                        <strong>Ação: </strong> {{ props.row.name }}
                      </span>
                      <span
                        ><strong> Data: </strong>
                        {{
                          props.row.pivot.created_at
                            .split(" ")[0]
                            .split("-")
                            .reverse()
                            .join("/")
                        }}</span
                      >
                    </div>
                    <div class="row col-12 text-brand-5">
                      <span
                        ><strong>Solicitante: </strong>
                        {{ dados.solicitante }}</span
                      >
                    </div>
                    <div class="row col-12 text-brand-5">
                      <span
                        ><strong>Observação: </strong>
                        {{ props.row.pivot.comment }}</span
                      >
                    </div>
                  </div>
                  <div class="col text-grid-table text-brand-5">
                    <div><strong>Assinatura:</strong></div>
                    <div class="q-ml-sm q-mt-sm">
                      <q-img
                        v-if="
                          props.row.pivot.auth_type != 'token' &&
                          props.row.pivot.auth_type != null
                        "
                        :src="props.row.pivot.auth_content"
                        fit="contain"
                        style="max-width: 40px; height: 5z5px"
                      />
                      <div v-else style="font-size: 10px">
                        {{ "Assinatura Eletrônica" }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template #body-cell-acao="props">
            <q-td :props="props">
              <div>
                {{ props.row.name }}
              </div>
            </q-td>
          </template>
          <template #body-cell-nome="props">
            <q-td :props="props">
              <div>{{ props.row.pivot.user.name }}</div>
            </q-td>
          </template>
          <template #body-cell-observacao="props">
            <q-td :props="props">
              <div>{{ props.row.pivot.comment }}</div>
            </q-td>
          </template>
          <template #body-cell-data="props">
            <q-td :props="props">
              <div>
                {{
                  props.row.pivot.created_at
                    .split(" ")[0]
                    .split("-")
                    .reverse()
                    .join("/")
                }}
                <p style="margin: 0 0 0 0px">
                  {{ props.row.pivot.created_at.split(" ")[1] }}
                </p>
              </div>
            </q-td>
          </template>
          <template #body-cell-tipoAutenticacao="props">
            <q-td :props="props">
              <div>{{ props.row.pivot.auth_type }}</div>
            </q-td>
          </template>
          <template #body-cell-autenticacao="props">
            <q-td :props="props">
              <q-img
                v-if="
                  props.row.pivot.auth_type != 'token' &&
                  props.row.pivot.auth_type != null
                "
                :src="props.row.pivot.auth_content"
                fit="contain"
                style="max-width: 40px; height: 5z5px"
              />
              <div v-else>
                {{ "Assinatura Eletrônica" }}
              </div>
            </q-td>
          </template>
        </q-table>
      </div>
    </div>
    <div
      v-if="requisicaoDetalhes.status == 'Aprovado'"
      class="col-12 q-ml-lg q-mt-xl container-assinatura-responsiva"
    >
      <div class="text-brand-5 text-weight-bold q-mb-sm">
        Tipo de Assinatura
      </div>
      <div class="text-brand-5 text-weight-bold q-mt-sm">
        <q-radio
          v-if="
            !$store.state.autenticacao.cliente.includes('staging-vale') &&
            !$store.state.autenticacao.cliente.includes('vale-epiexpress') &&
            $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
              'voucher-auth-assinatura'
            ) != -1
          "
          label="Assinatura"
          val="assinatura"
          v-model="tipoAssinatura"
        />
        <q-radio
          v-if="
            !mobile &&
            $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
              'voucher-auth-biometria'
            ) != -1
          "
          label="Biometria"
          val="biometria"
          v-model="tipoAssinatura"
        />
        <q-radio
          v-if="
            !$store.state.autenticacao.cliente.includes('staging-acciona') &&
            !$store.state.autenticacao.cliente.includes('acciona') &&
            $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
              'voucher-auth-pin'
            ) != -1
          "
          v-model="tipoAssinatura"
          label="PIN"
          val="web_pin"
          :size="mobile ? 'sm' : 'lg'"
        />
        <q-radio
          v-if="
            $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
              'voucher-auth-token'
            ) != -1
          "
          v-model="tipoAssinatura"
          label="Token"
          val="token"
          :size="mobile ? 'sm' : 'lg'"
        />
        <div
          v-if="
            $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
              'voucher-auth-pin'
            ) == -1 &&
            $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
              'voucher-auth-biometria'
            ) == -1 &&
            $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
              'voucher-auth-assinatura'
            ) == -1
          "
          class="q-my-md"
        >
          <span
            >Você não possui nenhum método de autenticação associado ao seu
            usuário, entre em contato com o suporte.</span
          >
        </div>
      </div>
      <div
        class="row col-12 q-mt-lg q-ml-md items-center container-autenticacao-pin"
        v-if="
          tipoAssinatura === 'web_pin' &&
          $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
            'voucher-auth-pin'
          ) != -1
        "
      >
        <q-icon class="q-mr-xs" name="lock" size="28px" />
        <div class="col-md-2 col-xs-6">
          <q-input v-model="pin" type="password" dense outlined />
        </div>
      </div>
      <div
        v-if="
          tipoAssinatura == 'assinatura' &&
          $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
            'voucher-auth-assinatura'
          ) != -1
        "
        class="row col-12 q-mt-md canvas-container"
      >
        <Canvas @update="recebeAssinatura" :go="salvarAssinatura" />
      </div>
      <div
        v-if="
          tipoAssinatura == 'biometria' &&
          $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
            'voucher-auth-biometria'
          ) != -1
        "
      >
        <div class="q-mt-md" v-if="requisicaoDetalhes.plantiff?.biometry">
          <q-img
            v-if="usuarioVerificado"
            class="imagem-biometria"
            src="../../../assets/bioOK.png"
            @click="verificarBiometria = !verificarBiometria"
          />
          <q-img
            v-else
            class="imagem-biometria"
            src="../../../assets/bioRequest.png"
            @click="verificarBiometria = !verificarBiometria"
          />
          <span class="q-ml-sm text-bold text-brand-5" style="font-size: 16px"
            >Clique no icone da digital para reconhecimento da biometria, após
            leitura, clique em CONFIRMAR ENTREGA</span
          >
          <Biometria
            :modal="verificarBiometria"
            :userId="dados.solicitanteId"
            :titulo="'Verificação de Biometria'"
            :tipoBiometria="'verificacao'"
            @negativePrint="recebeBiometria"
            @resultadoVerificacao="receberResultadoBiometria"
          />
        </div>
        <div class="q-mt-md" v-else>
          <q-img
            class="imagem-biometria"
            src="../../../assets/bioNO.png"
            @click="verificarBiometria = !verificarBiometria"
          />
          <span class="q-ml-sm text-bold text-brand-5" style="font-size: 14px"
            >O funcionário não possuiu biometria cadastrada, favor clicar no
            icone e realizar o procedimento de cadastro antes da finalização da
            requisição</span
          >
          <Biometria
            :modal="verificarBiometria"
            :userId="dados.solicitanteId"
            :titulo="'Cadastro de Biometria'"
            :tipoBiometria="'cadastro'"
            @atualizarBiometrias="atualizarTemplatesBiometria"
          />
        </div>
      </div>
    </div>
    <div
      class="row container-observacao-row q-mt-xl text-brand-5 text-weight-bold text-body q-ml-lg"
    >
      <div
        class="observacao-container"
        v-if="requisicaoDetalhes.status != 'Finalizado'"
      >
        <div class="q-ml-sm titulo-pagina-principal q-mb-sm">
          Mensagem para a Aprovação desta Fase
          <span class="sub-text">(Máximo 255 caracteres)</span>
        </div>
        <q-input
          type="textarea"
          dense
          outlined
          placeholder="Deixe uma mensagem para a aprovação desta etapa."
          v-model="mensagemFase"
        />
      </div>
      <div class="row col-12 q-gutter-xs q-mt-md">
        <div
          class="col-md-2 col-xs-5 col-sm-5"
          v-if="
            requisicaoDetalhes.status == 'Aprovado' ||
            requisicaoDetalhes.status == 'Pendente'
          "
        >
          <q-btn
            class="btn"
            :label="
              requisicaoDetalhes.status == 'Pendente'
                ? 'Aprovar Requisição'
                : 'Finalizar Requisição'
            "
            no-caps
            color="positive"
            icon="check_circle_outline"
            @click="
              requisicaoDetalhes.status == 'Pendente'
                ? aprovar()
                : tipoFinalizacao()
            "
          />
        </div>
        <div
          class="col-md-2 col-xs-5 col-sm-5"
          v-if="requisicaoDetalhes.status == 'Pendente'"
        >
          <q-btn
            class="btn"
            label="Reprovar Requisição"
            no-caps
            color="negative"
            icon="cancel"
            @click="reprovarRequisicao()"
          />
        </div>
        <div
          class="col-md-2 col-xs-5 col-sm-5"
          v-if="
            requisicaoDetalhes.status == 'Aprovado' ||
            requisicaoDetalhes.status == 'Pendente'
          "
        >
          <q-btn
            label="Atualizar Quantidade"
            no-caps
            class="btn"
            color="primary"
            icon="sync"
            @click="atualizarValores()"
          />
        </div>
      </div>
    </div>
    <TabelaHistoricoRetirada
      :solicitanteId="dados?.sap"
      :item="item"
      :atualizar="atualizarHistorico"
    />
    <q-dialog v-model="confirm" persistent>
      <q-card
        class="q-pa-sm container-modal-excluir text-brand-5 text-weight-bolder q-pa-xl"
      >
        <q-card-section class="row col-12 justify-center">
          <span class="texto-excluir-pai"
            >TEM CERTEZA QUE DESEJA CRIAR A TRANSFERÊNCIA?</span
          >
        </q-card-section>

        <div class="row col-12 justify-center">
          <q-btn
            no-caps
            label="Sim"
            color="positive"
            v-close-popup
            class="btn-excluir"
            icon="check_circle_outline"
            @click="criarTransferencia()"
          />
          <q-btn
            icon="cancel"
            no-caps
            label="Cancelar"
            color="negative"
            class="btn-excluir q-ml-md"
            v-close-popup
          />
        </div>
      </q-card>
    </q-dialog>
    <div
      v-if="rightDrawerOpen"
      @click="rightDrawerOpen = false"
      class="mascara"
    ></div>
  </q-page>
</template>

<script>
import { onMounted, watch } from "@vue/runtime-core";
import { ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";

import Canvas from "../../requisicao/components/Canvas.vue";
import Biometria from "../../biometria/views/BiometriaTeste.vue";
import TabelaHistoricoRetirada from "../../requisicao/components/TabelaHistoricoRetirada.vue";
// import ModalInformacaoesAdicionais from "../components/ModalInformacaoesAdicionais.vue";

const columns = [
  {
    name: "selecionado",
    label: "Produtos Selecionados",
    align: "center",
    sortable: false,
  },
  {
    name: "imagem",
    label: "Imagem",
    align: "left",
    sortable: false,
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
    sortable: false,
  },
  {
    name: "nome",
    label: "Nome",
    align: "left",
    sortable: false,
  },
  {
    name: "estoque",
    label: "Estoque",
    align: "left",
    sortable: false,
  },
  {
    name: "grupoProduto",
    label: "Grupo de Produto",
    align: "left",
    sortable: false,
  },
  {
    name: "quantidade",
    label: "QTD",
    align: "left",
    sortable: false,
  },
  {
    name: "quantidadeEntregue",
    label: "Quantidade Entregue",
    align: "left",
    sortable: false,
  },
  {
    name: "lote",
    label: "Lote",
    align: "left",
  },
  {
    name: "retiradas",
    label: "Retiradas",
    align: "left",
  },
];
const columns2 = [
  {
    name: "acao",
    label: "Ação",
    align: "center",
    sortable: false,
  },
  {
    name: "nome",
    label: "Nome Requisitante",
    align: "left",
    sortable: false,
  },
  {
    name: "observacao",
    label: "Observação",
    align: "left",
    sortable: false,
  },
  {
    name: "data",
    label: "Data",
    align: "center",
    sortable: false,
  },
  {
    name: "tipoAutenticacao",
    label: "Tipo de Autenticação",
    align: "left",
    sortable: false,
  },
  {
    name: "autenticacao",
    label: "Autenticação",
    align: "left",
    sortable: false,
  },
];
export default {
  components: {
    Canvas,
    Biometria,
    TabelaHistoricoRetirada,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const quasar = useQuasar();
    const confirm = ref(false);
    const informarDataRetroativa = ref(false);
    const requisicaoId = route.params.requisicaoId;
    const rightDrawerOpen = ref(false);
    const requisicaoDetalhes = ref([]);
    const assinaturaDesabilitado = ref(["staging-vale", "vale"]);
    const assinaturaDesabilitadoVariable = ref(true);
    let loading = ref(false);
    const dados = ref({
      centroDeCusto: "",
      solicitante: "",
      solicitanteId: "",
      descricao: "",
      produtos: [],
      historico: [],
      ordem: null,
      dataRetroativa: null,
    });
    const tipoAssinatura = ref("assinatura");
    const unidadeTransferencia = ref("");
    const description = ref("");
    let imagemBase64 = ref(null);
    const mensagemFase = ref(undefined);
    const userLogadoId = ref("");
    let salvarAssinatura = ref(0);
    const lotes = ref([]);
    const batchsName = ref("");
    const batchsQuantidade = ref(0);
    const nextId = ref(0);
    let uploadArquivo = ref(false);
    let verificarBiometria = ref(false);
    const pin = ref("");
    let usuarioVerificado = ref(false);
    const atualizarHistorico = ref(0);
    let mobile = ref(false);
    const item = ref({ nome: "", id: "" });
    const objetoUnidade = ref({
      nome: "",
      id: "",
    });
    const time = ref(null);
    const listaOrdem = ref([]);
    if (quasar.platform.is.mobile) {
      mobile = ref(true);
      dados.value.tipoAutenticacao = "web_pin";
    }

    const detalheRequisicao = async () => {
      store.dispatch("pdt/hiddenHeader", true);
      lotes.value = [];
      loading.value = true;
      try {
        let response = await store.dispatch("requisicao/detalharVoucher", {
          voucher_id: requisicaoId,
        });
        requisicaoDetalhes.value = response.data.model;
        objetoUnidade.value = {
          nome: requisicaoDetalhes.value?.vendor?.name,
          id: requisicaoDetalhes.value?.vendor?.id,
        };
        dados.value.centroDeCusto = requisicaoDetalhes.value.cost_center.name;
        dados.value.solicitante = requisicaoDetalhes.value.plantiff.name;
        dados.value.solicitanteId = requisicaoDetalhes.value.plantiff.id;
        dados.value.sap = requisicaoDetalhes.value.plantiff.sap;
        dados.value.descricao = requisicaoDetalhes.value.description;
        dados.value.produtos = requisicaoDetalhes.value.products;
        dados.value.historico = requisicaoDetalhes.value.applications;
        dados.value.ordem = requisicaoDetalhes.value.os;
        dados.value.produtos.forEach((e) => {
          e.lotes.sort((a, b) => {
            if (a.expiration_date == null || b.expiration_date == null) {
              if (a.expiration_date == null) {
                return -1;
              }
              if (b.expiration_date == null) {
                return 1;
              }
            }
            if (a.expiration_date != null && b.expiration_date != null) {
              if (a.expiration_date > b.expiration_date) {
                return 1;
              }
              if (b.expiration_date > a.expiration_date) {
                return -1;
              }
            }
            return 0;
          });

          if (e.lotes.length > 0 && e.stock[0].pivot.batch_control == 1) {
            if (parseFloat(e.lotes[0].amount) < 0) {
              adicionarLote(e.id, e.pivot.amount, "");
            } else {
              adicionarLote(e.id, e.pivot.amount, e.lotes[0].batch);
            }
          } else {
            adicionarLote(e.id, e.pivot.amount, "");
          }
        });
      } catch (error) {
        console.log(error);
      }
      loading.value = false;
    };

    const atualizarValores = async () => {
      description.value = "";
      let products = [];
      requisicaoDetalhes.value.products.forEach((e) => {
        if (e.pivot.new_amount && e.pivot.amount != e.pivot.new_amount) {
          description.value += `${e.code} foi alterado de ${e.pivot.amount} para ${e.pivot.new_amount} - `;
          products.push({
            id: e.id,
            amount: e.pivot.new_amount,
          });
        } else {
          products.push({
            id: e.id,
            amount: e.pivot.amount,
          });
        }
      });
      try {
        await store.dispatch("requisicao/atualizarQuantidade", {
          voucher_id: requisicaoDetalhes.value.id,
          description: description.value,
          products: products,
        });
        quasar.notify({
          message: "Quantidade atualizada",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        detalheRequisicao();
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao atualizar quantidade",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const reprovarRequisicao = async () => {
      try {
        await store.dispatch("requisicao/excluir", {
          reqId: requisicaoId,
        });
        quasar.notify({
          message: "Requisição reprovada",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        router.push({ name: "backoffice/listagem-requisicoes-teste" });
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao reprovar requisição",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const recebeAssinatura = async (value) => {
      imagemBase64.value = value;
      usuarioVerificado.value = true;
      finalizarRequisicao();
    };

    const recebeBiometria = async (value) => {
      imagemBase64.value = value;
    };

    const userLogado = async () => {
      let response = await store.dispatch("requisicao/userLogado");
      userLogadoId.value = response.data.id;
    };

    const finalizarRequisicao = async () => {
      let valido = true;
      dados.value.produtos.forEach((produto) => {
        if (produto.pivot.new_amount) {
          atualizarValores();
          valido = false;
        }
      });
      if (valido) {
        let batches = [];
        lotes.value.forEach((lote) => {
          if (lote.batch != "") {
            batches.push({
              batch: lote.batch,
              amount: lote.amount,
              product_id: lote.productId,
            });
          }
        });
        if (
          tipoAssinatura.value != "token" &&
          !imagemBase64.value &&
          imagemBase64.value == undefined
        ) {
          quasar.notify({
            message:
              "É necessário usar um metodo de autenticação para a finalização.",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }

        if (!usuarioVerificado.value) {
          quasar.notify({
            message: "A Biometria coletada não coincide com a do solicitante",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }
        try {
          await store.dispatch("requisicao/finalizar", {
            reqId: requisicaoId,
            imagemBase64:
              tipoAssinatura.value != "token"
                ? imagemBase64.value
                : "TOKEN GERADO NO LOGIN",
            idUsuario: dados.value.solicitanteId,
            date:
              dados.value.dataRetroativa != null
                ? converterData(dados.value.dataRetroativa)
                : gerarTimestamp(),
            batches: batches,
            mensagem: mensagemFase.value,
            auth_type: tipoAssinatura.value,
          });
          enviarImageBiometria();
          quasar.notify({
            message: "Requisição finalizada com sucesso",
            color: "positive",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          router.push({ name: "backoffice/listagem-requisicoes-teste" });
        } catch (error) {
          quasar.notify({
            message: error.response.data.message,
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const adicionarLote = async (id, quantidade, nome) => {
      batchsName.value = nome;
      batchsQuantidade.value = quantidade;
      lotes.value.push({
        batch: batchsName.value,
        amount: batchsQuantidade.value,
        id: nextId.value,
        productId: id,
      });
      batchsName.value = "";
      batchsQuantidade.value = 0;
      nextId.value++;
    };

    const enviarImageBiometria = async () => {
      try {
        await store.dispatch("requisicao/enviarImageBiometria", {
          voucher_id: requisicaoId,
          image: imagemBase64.value,
        });
      } catch (error) {
        console.log(error);
      }
    };

    const removerLote = (index) => {
      lotes.value.splice(index, 1);
    };

    //Ordem de serviço

    const listarOrdem = async (value) => {
      try {
        const response = await store.dispatch("requisicao/listarOrdem", {
          per_page: 10,
          numero: value,
        });

        listaOrdem.value = response.data.data;
      } catch (error) {
        console.log(error);
      }
    };

    const converterData = (data) => {
      let partesData = data.split("/");
      let dataObjeto = new Date(
        partesData[2],
        partesData[1] - 1,
        partesData[0],
        0,
        0,
        0
      );
      dataObjeto.setUTCHours(0, 0, 0, 0);
      return dataObjeto.toISOString();
    };

    const setOrdem = async () => {
      try {
        await store.dispatch("requisicao/escolherOrdem", {
          voucher_id: requisicaoId,
          osid: dados.value.ordem.uuid,
        });
        quasar.notify({
          message: "Ordem Adicionada com sucesso",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        detalheRequisicao();
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro a o adicionar Ordem",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const removerOrdem = async () => {
      try {
        await store.dispatch("requisicao/removerOrdem", {
          voucher_id: requisicaoId,
          osid: dados.value.ordem.uuid,
        });

        quasar.notify({
          message: "Ordem removida com sucesso",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        detalheRequisicao();
      } catch (error) {
        quasar.notify({
          message: "Erro a o adicionar Ordem",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const editarQuantidade = (id, quantidade) => {
      lotes.value.forEach((e) => {
        if (id == e.id) {
          e.amount = quantidade;
        }
      });
    };

    const editarNomeLote = (id, nome) => {
      lotes.value.forEach((e) => {
        if (id == e.id) {
          e.batch = nome;
        }
      });
    };

    const options = (produtoId, controle) => {
      let options = [];

      dados.value.produtos.forEach((e) => {
        if (e.id == produtoId) {
          e.lotes.forEach((lote) => {
            if (parseFloat(lote.amount) > 0) {
              if (controle == 1) {
                setDefaultValue(lote);
              }

              options.push(lote.batch);
            }
          });
        }
      });
      return options;
    };

    const setDefaultValue = async (lote) => {
      if (lotes.value[0].batch != "") {
        return;
      } else {
        lotes.value[0].batch =
          parseFloat(lote.amount) >= parseFloat(lotes.value[0].amount)
            ? lote.batch
            : lotes.value[0].batch;
      }
    };

    const aprovar = async () => {
      try {
        await store.dispatch("requisicao/aprovar", {
          reqId: requisicaoId,
        });
        router.push({ name: "backoffice/listagem-requisicoes-teste" });
        quasar.notify({
          message: "Requisição aprovada com sucesso",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao aprovar requisição",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        console.log(error);
      }
    };

    const arquivos = async () => {
      router.push({ name: "requisicao-arquivos", params: requisicaoId });
    };

    const verificaArquivoUpload = async () => {
      try {
        let response = await store.dispatch("requisicao/listarDocumentos", {
          voucher_id: requisicaoId,
        });
        let array = response.data.result;

        if (array.length > 0) {
          uploadArquivo.value = true;
        }
      } catch (error) {
        console.log(error);
      }
    };

    const tipoFinalizacao = () => {
      if (
        tipoAssinatura.value == "biometria" ||
        tipoAssinatura.value == "token"
      ) {
        finalizarRequisicao();
        return;
      }
      if (tipoAssinatura.value == "web_pin") {
        verificarPin();
        return;
      }
      salvarAssinatura.value++;
    };

    const verificarPin = async () => {
      if (pin.value == "") {
        quasar.notify({
          message: "O campo de pin não pode ser vazio",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        const response = await store.dispatch("requisicao/checarPin", {
          pin: pin.value,
          user_id: dados.value.solicitanteId,
        });
        if (response.data.result.pin_correto) {
          quasar.notify({
            message:
              "Senha Validada com Sucesso, a requisição será finalizada!",
            color: "positive",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          imagemBase64.value = pin.value;
          usuarioVerificado.value = true;
          finalizarRequisicao();
        } else {
          quasar.notify({
            message: "PIN digitado, não corresponde ao pin do usuário!",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      } catch (error) {
        quasar.notify({
          message: "Erro ao validar pin",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const receberResultadoBiometria = (value) => {
      usuarioVerificado.value = value;
    };

    const atualizarTemplatesBiometria = async () => {
      try {
        await store.dispatch("user/atualizarTemplatesBiometria");
        detalheRequisicao();
      } catch (error) {
        console.log(error);
      }
    };

    const gerarTimestamp = () => {
      let dataAtual = new Date();

      let ano = dataAtual.getFullYear();
      let mes = (dataAtual.getMonth() + 1).toString().padStart(2, "0");
      let dia = dataAtual.getDate().toString().padStart(2, "0");
      let horas = dataAtual.getHours().toString().padStart(2, "0");
      let minutos = dataAtual.getMinutes().toString().padStart(2, "0");
      let segundos = dataAtual.getSeconds().toString().padStart(2, "0");

      return `${ano}-${mes}-${dia}T${horas}:${minutos}:${segundos}Z`;
    };

    const retornarValorEstoque = (value) => {
      let estoque = value.filter(
        (value) => value.vendor_id === objetoUnidade.value.id
      );
      if (estoque.length > 0) {
        return parseFloat(estoque[0].amount).toFixed(2);
      }
    };

    const criarTransferencia = async () => {
      if (requisicaoDetalhes.value.status != "Finalizado") {
        quasar.notify({
          message:
            "Só é possivel criar uma transferencia no status 'finalizado'.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (
        unidadeTransferencia.value?.id === undefined ||
        unidadeTransferencia.value?.id === ""
      ) {
        quasar.notify({
          message: "Escolha a unidade de destino.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (
        requisicaoDetalhes.value.vendor.id == unidadeTransferencia.value?.id
      ) {
        quasar.notify({
          message: "A unidade de destino não pode ser igual a origem.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        const response = await store.dispatch("requisicao/criarTransferencia", {
          deposito_id_entrada: unidadeTransferencia.value?.id,
          deposito_id_saida: requisicaoDetalhes.value.vendor.id,
          descricao: `Transferência criada a partir da requisição de número ${requisicaoId}.`,
          solicitante_id: dados.value.solicitanteId,
          transferir_estoque: 0,
        });
        quasar.notify({
          message: "Transferência criada com sucesso.",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        adicionarProdutoTransferencia(response.data.result.id);
      } catch (error) {
        console.log(error);
      }
    };

    const adicionarProdutoTransferencia = async (id_transferencia) => {
      let produtos = [];
      if (requisicaoDetalhes.value.products.length > 0) {
        requisicaoDetalhes.value.products.forEach((produto) => {
          produtos.push({
            id: produto.id,
            quantidade: produto.pivot.amount,
          });
        });
      }
      try {
        await store.dispatch("transferencia/adicionarProduto", {
          id_transferencia,
          action: "adicionar-produto",
          transferir_estoque: 0,
          produtos,
        });
        router.push({
          name: "transferencia-detalhe",
          params: { transferenciaId: id_transferencia },
        });
        quasar.notify({
          message:
            "Produtos adicionados na transferência com sucesso. Você será redirecionado para detalhe.",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
        quasar.notify({
          message:
            "Erro ao adicionar produtos, você precisará fazer isso manualmente. Você será redirecionado a transferência criada.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        router.push({
          name: "transferencia-detalhe",
          params: { transferenciaId: id_transferencia },
        });
      }
    };

    watch(
      () => tipoAssinatura.value,
      () => {
        if (tipoAssinatura.value == "token") {
          usuarioVerificado.value = true;
          imagemBase64.value = null;
          pin.value = "";
          return;
        }
        imagemBase64.value = null;
        pin.value = "";
        usuarioVerificado.value = false;
      }
    );

    const validacaoTenent = async () => {
      const subdomain = window.location.host.split(".")[1]
        ? window.location.host.split(".")[0]
        : "";

      assinaturaDesabilitado.value.forEach((e) => {
        if (subdomain.indexOf(e) != -1) {
          assinaturaDesabilitadoVariable.value = false;
          tipoAssinatura.value = "biometria";
        }
      });
    };

    const receberUnidadeTransferencia = (value) => {
      unidadeTransferencia.value = value;
    };

    watch(
      () => dados.value.ordem,
      () => {
        if (requisicaoDetalhes.value.os == dados.value.ordem) {
          return;
        }
        setOrdem();
      }
    );

    onMounted(detalheRequisicao);
    onMounted(userLogado);
    onMounted(verificaArquivoUpload);
    onMounted(validacaoTenent);

    return {
      columns,
      columns2,
      dados,
      detalheRequisicao,
      requisicaoId,
      adicionarProdutoTransferencia,
      requisicaoDetalhes,
      tipoAssinatura,
      atualizarValores,
      description,
      loading,
      criarTransferencia,
      reprovarRequisicao,
      finalizarRequisicao,
      imagemBase64,
      mensagemFase,
      userLogado,
      recebeAssinatura,
      retornarValorEstoque,
      salvarAssinatura,
      adicionarLote,
      lotes,
      batchsName,
      objetoUnidade,
      batchsQuantidade,
      nextId,
      removerLote,
      options,
      editarQuantidade,
      aprovar,
      arquivos,
      verificaArquivoUpload,
      uploadArquivo,
      editarNomeLote,
      receberUnidadeTransferencia,
      verificarBiometria,
      userLogadoId,
      enviarImageBiometria,
      recebeBiometria,
      tipoFinalizacao,
      pin,
      verificarPin,
      receberResultadoBiometria,
      unidadeTransferencia,
      usuarioVerificado,
      converterData,
      atualizarTemplatesBiometria,
      confirm,
      gerarTimestamp,
      mobile,
      atualizarHistorico,
      item,
      assinaturaDesabilitadoVariable,
      setDefaultValue,
      listaOrdem,
      rightDrawerOpen,
      informarDataRetroativa,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      filterOrdem(val, update) {
        clearTimeout(time.value);
        time.value = setTimeout(() => {
          listarOrdem(val);
        }, 1000);

        setTimeout(() => {
          update();
        }, 1000);
      },
      setOrdem,
      removerOrdem,
    };
  },
};
</script>

<style scoped>
.imagem-biometria {
  height: 80px;
  width: 80px;
  cursor: pointer;
}
a {
  text-decoration: none;
}
input[type="file"] {
  display: none;
}
.btn-adicionar {
  display: inline-block;
  background-color: #58afc1;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  margin: 5px 5px 0 0;
  padding: 6px 20px;
  padding-left: 40px;
}
.text {
  display: inline;
}
ul {
  list-style: none;
}
.container {
  position: relative;
}
.icon {
  position: absolute;
  top: 37px;
  left: 9px;
}
.icon-voltar {
  font-size: 24px;
}
.observacao-container {
  width: 60%;
}
.img-container {
  border: 2px solid gray;
  border-radius: 5px;
  font-weight: bold;
  width: 50px;
  height: 50px;
}
.img-normal {
  max-width: 100%;
  height: 100%;
}
.botao-imprimir {
  margin-top: 22px;
}
.icon-voltar {
  font-size: 25px;
}
.texto-titulo {
  font-size: 20px;
}
.mascara {
  background-color: black;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
.container-modal-excluir {
  width: 590px;
}
.texto-excluir-pai {
  text-align: center;
  text-justify: inter-word;
  font-size: 23px;
  font-weight: bold;
  color: black;
}
.btn-excluir {
  font-size: 16px;
  padding: 0px 25px;
}
@media only screen and (max-width: 635px) {
  .container-titulo-principal {
    margin-top: 10px;
  }
  .texto-titulo {
    font-size: 16px;
  }
  .titulo-pagina-principal {
    font-size: 14px;
  }
  .icon-voltar {
    font-size: 15px;
    margin-top: 8px !important;
    margin-right: 7px;
  }
  .container-inputs {
    margin: 0 0 0 0;
  }
  .titulo-inputs {
    font-size: 12px;
    margin: 0px;
  }
  .input-font {
    font-size: 11px;
  }
  .titulo-tabela {
    margin: 30px 0px 0px 0px;
  }
  .texto-titulo-tabela {
    margin-left: 9px;
    font-size: 14px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .text-grid-table {
    font-size: 12px;
  }
  .arrow {
    color: white;
    font-size: 25px;
    border-radius: 5px;
    cursor: pointer;
  }
  .input-grid {
    width: 10px;
  }
  .numero {
    color: #fff;
  }
  .card-img {
    border: 1px solid #707070;
    border-radius: 5px;
    height: 80px;
  }
  .input-quantidade-container {
    margin-bottom: 29px;
  }
  .input-quantidade {
    font-size: 14px;
    width: 26px;
    height: 12px;
    padding-left: 5px;
  }
  .observacao-container {
    width: 100%;
  }
  .container-observacao-row {
    width: 100%;
    margin: 30px 0 0 0;
    padding: 0px;
  }
  .sub-text {
    font-size: 12px;
    opacity: 0.8;
  }
  .btn {
    font-size: 12px !important;
    margin-top: 8px;
  }
  .container-assinatura-responsiva {
    margin: 30px 0px 0px 0px;
  }
  .canvas-container {
    width: 100%;
  }
  .container-btn-arquivo {
    margin: 30px 0px 40px 5px;
  }
  .btn-adicionar {
    background-color: #58afc1;
    cursor: pointer;
    margin: 5px 5px 0 0;
    padding: 4px 20px;
    padding-left: 40px;
    font-size: 12px;
  }
  .icon {
    position: absolute;
    top: 35px;
    left: 9px;
  }
  .btn-enviar-container {
    margin: 0px;
  }
  .img-grid {
    max-width: 100%;
    height: 100%;
  }
  .input-lote-nome {
    width: 100px;
    font-size: 11px;
  }
  .input-lote-qtd {
    width: 80px;
    margin-left: 5px;
    font-size: 11px;
  }
  .btn-delete {
    font-size: 11px;
    margin: 0px;
    padding: 0px 0px 0px 5px;
  }
  .text-campos-lotes {
    font-size: 12px;
    margin: 0px 4px;
  }
  .text-lotes-existentes {
    font-size: 11px;
  }
  .botao-imprimir {
    margin-top: 19px;
  }
  .btn-modal {
    font-size: 12px;
  }
  .container-modal-excluir {
    width: 100%;
    height: 250px;
    padding: 10px 10px 0px 10px;
    margin: 0px;
    border-radius: 10px;
  }
  .texto-excluir-pai {
    font-size: 17px;
  }
  .btn-excluir {
    font-size: 14px;
  }
}
@media only screen and (max-width: 387px) {
  .input-lote-nome {
    width: 100px;
    font-size: 11px;
  }
  .texto-titulo {
    font-size: 16px;
  }
  .icon-voltar {
    font-size: 20px;
    margin-right: 1px;
  }
}
@media only screen and (max-width: 370px) {
  .input-lote-nome {
    width: 90px;
    font-size: 11px;
  }
  .texto-titulo {
    font-size: 16px;
  }
  .btn {
    font-size: 10px !important;
  }
  .input-lote-qtd {
    width: 60px;
  }
  .icon-voltar {
    font-size: 20px;
    margin-right: 1px;
  }
}
</style>
